import React from 'react';
import { Navigate } from 'react-router';
import { Button } from '@rezi/ui/button';
import { Card } from '@rezi/ui/card';
import { useAuth } from '../auth';

const LoginPage = () => {
  const { signInWithGoogle, loading, error, user } = useAuth();

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <Card className="flex w-full max-w-md flex-col gap-4">
        <div className="text-text text-xl font-semibold">Internal Docs</div>
        <p className="text-sm text-gray-500">
          Sign in with your @rezi.io Google account to continue.
        </p>
        {error && <div className="text-sm text-red-600">{error}</div>}
        <Button
          label={loading ? 'Checking session...' : 'Sign in with Google'}
          theme="primary"
          size="medium"
          onClick={signInWithGoogle}
          disabled={loading}
        />
      </Card>
    </div>
  );
};

export default LoginPage;
